import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  ActValidationErrorModel,
  SetActValidationErrorsAction,
  SetTabValidationErrorsAction,
  TabValidationErrorModel,
} from 'app/shared/reducers/validationerrors/model/validation-errors.model';
import { IRootState } from 'app/config/store';
import { revalidateTabs } from 'app/edozvola/cases/service/cases.service';
import { revalidateCaseActs } from 'app/edozvola/cases/cases-service';

export const initialValidationErrorState = {
  idCase: null,
  tabValidationErrors: [
    {
      tabKey: '',
      tableValidationErrors: [],
    } as TabValidationErrorModel,
  ],
  actValidationErrors: [] as ActValidationErrorModel[],
};

export type ValidationErrorState = Readonly<typeof initialValidationErrorState>;

const ValidationErrors = createSlice({
  name: 'validationErrorSlice',
  initialState: initialValidationErrorState as ValidationErrorState,
  reducers: {
    initTabValidationErrors() {
      return initialValidationErrorState;
    },
    setTabValidationErrors(state, action: SetTabValidationErrorsAction) {
      return { ...action.payload, actValidationErrors: state.actValidationErrors } as ValidationErrorState;
    },
    setActValidationErrors(state, action: SetActValidationErrorsAction) {
      return { ...state, actValidationErrors: action.payload } as ValidationErrorState;
    },
  },
});

export const revalidateTabsThunk = createAsyncThunk('validationErrorSlice/revalidateTabsThunk', async (_, { dispatch, getState }) => {
  const state: IRootState = getState();
  if (state.validationErrors.tabValidationErrors && state.validationErrors.idCase) {
    await revalidateTabs(state.validationErrors).then(response => dispatch(setTabValidationErrors(response)));
  }
});

export const revalidateCaseActsThunk = createAsyncThunk(
  'validationErrorSlice/revalidateCaseActsThunk',
  async (_, { dispatch, getState }) => {
    const state: IRootState = getState();
    if (state.validationErrors.actValidationErrors) {
      await revalidateCaseActs(state.validationErrors).then(response => dispatch(setActValidationErrors(response)));
    }
  },
);

export const { setTabValidationErrors, initTabValidationErrors, setActValidationErrors } = ValidationErrors.actions;
export default ValidationErrors.reducer;
